import styled from 'styled-components';

interface Props {
  islast?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: clamp(1.25rem, 3vw, 3.125rem);  
  padding-block: clamp(0.75rem, 1.5vw, 1.25rem);  
  gap: clamp(0.75rem, 1.5vw, 1.25rem);

  @media (max-width: 768px) {
    padding-inline: clamp(0.75rem, 1.5vw, 1.25rem);
  }
`;

export const InfoContainer = styled.div`
  font-weight: 700;
  cursor: pointer;
  @media (max-width: 1024px) {
    width: 60%;
    padding: clamp(1.25rem, 2vw, 1.875rem);
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: clamp(0.75rem, 1.5vw, 1.25rem);
  }
`;

export const OrderHeader = styled.div`
  background-color: ${props => props.theme.colors.card};
  border-radius: 10px;
  padding: clamp(0.5rem, 0.75vw, 0.625rem);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
`;

export const OrderDetails = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  
  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

export const OrderItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: clamp(0.5rem, 0.75vw, 0.625rem);
  padding: clamp(0.25rem, 0.5vw, 0.3125rem);
    
  & > * {
    flex: 1;
  }
  
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const HeaderTitle = styled.span`
  font-weight: 700;
  color: ${props => props.theme.colors.text};
  font-size: clamp(0.875rem, 1.2vw, 1rem);
`;

export const ContentTitle = styled.span`
  font-weight: 700;
  font-size: clamp(0.75rem, 1vw, 0.875rem);
  color: ${props => props.theme.colors.text};
`;

export const ContentSubtitle = styled.span`
  font-size: clamp(0.875rem, 1.2vw, 1rem);
  color: ${props => props.theme.colors.text};
`;

export const PedidoWrapper = styled.div<Props>`
  border: 1px solid;
  border-color: ${props => props.theme.colors.border_grey};
  border-bottom-left-radius: ${props => props.islast && '20px'};
  border-bottom-right-radius: ${props => props.islast && '20px'};
`;

export const PedidoContent = styled.div`
  padding: clamp(0.75rem, 1.5vw, 1.25rem);
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
`;

export const PedidoFooter = styled.div``;

export const Link = styled.span`
  white-space: pre-wrap;
  font-size: clamp(0.75rem, 1vw, 0.875rem);
  color: ${props => props.theme.colors.primary};
  transition: 200ms;
  align-self: flex-end;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`;